import { herobg } from "assets";
import styled from "styled-components";

export const MainDiv = styled.div`
  background-image: url(${herobg});
  background-repeat: no-repeat;
  background-size: cover;
  min-height: 100vh;

  @media (max-width: 990px) {
    background-image: none;
    min-height: auto;
  }

  @media (min-width: 990px) {
    .hero-img4 {
      display: none;
    }
  }

  .hero-img4 {
    width: 100%;
  }
`;

export const CardWrapper = styled.div`
  position: relative;
  width: 764px;
  height: 182px;

  @media (max-width: 990px) {
    width: 342px;
    height: 105.942px;
  }

  .img-div {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;

    @media (max-width: 990px) {
      display: none;
    }
  }
  .img-div2 {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;

    @media (min-width: 990px) {
      display: none;
    }
  }
`;

export const CardContent = styled.div`
  position: relative;

  h1 {
    color: #f7c13a;
    font-size: 96px;
    font-style: italic;
    font-weight: 400;
    line-height: normal;
    letter-spacing: 3.84px;
    text-align: center;
    margin: 0;

    @media (max-width: 990px) {
      font-size: 37.948px;
    }
  }

  p {
    color: #fff;
    leading-trim: both;
    text-edge: cap;
    text-shadow: 0px 4px 9.5px #000;
    font-size: 24px;
    font-style: italic;
    font-weight: 600;
    letter-spacing: 1.68px;
    text-align: center;
    margin-top: 0.5rem;

    span {
      color: #f7c13a;
    }

    @media (max-width: 990px) {
      font-size: 13px;
    }
  }
`;

export const MainSection = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 32rem;
  padding-bottom: 4rem;

  @media (max-width: 990px) {
    margin-top: 3rem;
    padding-bottom: 0rem;
  }

  .title {
    margin-top: 5rem;

    @media (max-width: 767px) {
      margin-top: 0rem;
    }
  }

  .rightdiv {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export const MainWrapper = styled.div`
  margin-top: 5rem;

  @media (max-width: 990px) {
    margin-top: 2rem;
  }

  @media (max-width: 767px) {
    .desktop-row {
      display: none;
    }
  }

  @media (min-width: 767px) {
    .mobile-row {
      display: none;
    }
  }
`;

export const Title = styled.h1`
  font-size: 86px;
  font-style: italic;
  font-weight: 400;
  letter-spacing: 0.04em;
  color: rgba(247, 193, 58, 1);

  @media (max-width: 767px) {
    font-size: 48px;
    text-align: center;
  }
`;

export const Text = styled.p`
  font-size: 20px;
  font-style: italic;
  font-weight: 600;
  letter-spacing: 0.14em;
  margin-top: 0.5rem;
  color: rgba(255, 255, 255, 1);

  span {
    color: rgba(247, 193, 58, 1);
  }

  @media (max-width: 767px) {
    font-size: 16px;
    text-align: center;
    margin-top: 1.5rem;
  }
`;

export const Mintbtn = styled.button`
  font-family: "Inter";
  font-size: 20.168px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  background: var(--yellow, linear-gradient(180deg, #e0c528 0%, #f7c13a 100%));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  border-radius: 5.5px;
  border: 1.833px solid var(--yellow, #e0c528);
  width: 183.347px;
  height: 54.087px;
  margin-top: 1rem;
  &:hover {
    background: #ffbe53;
    -webkit-text-fill-color: #000;
    border: none;
  }

  @media (max-width: 990px) {
    display: block;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 2rem;
    margin-top: 1.5rem;
    width: 100%;
  }
`;

export const Name = styled.h5`
  color: #fff;
  font-family: "Inter";
  font-size: 22.789px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-top: 1rem;
`;

export const NftId = styled.h5`
  color: #8e8c8c;
  font-size: 1.21044rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-align: start;
  margin: 0;
`;

export const Nftvalue = styled.h5`
  font-size: 1.21044rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  background: var(--yellow, linear-gradient(180deg, #e0c528 0%, #f7c13a 100%));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin: 0;
`;

export const CardInnerDiv2 = styled.div`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;

  .inner-img {
    margin-top: 1.7rem;
    width: 22.66769rem;
    height: 33.44863rem;
  }

  .innerimg2 {
    padding: 0rem 1.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  video {
    width: 100%;
    margin-top: 1.7rem;
  }
`;

export const CardWrapper2 = styled.div`
  position: relative;
  width: 100%;
  min-height: 471.058px;
  margin-top: -2rem;
  cursor: pointer;
  /* @media (min-width: 1602px) {
    height: 471.058px;
  }

  @media (max-width: 1450px) {
    height: 390.058px;
  }

  @media (max-width: 1400px) {
    height: 370.058px;
  } */

  .innerimg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
  }
`;

export const TextDiv2 = styled.div`
  padding: 0 1.5rem;
  margin-top: 1rem;

  .inner-div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 1rem;
  }

  h2 {
    text-align: start;
    margin: 0;
  }

  .img-div {
    display: flex;
    gap: 0.7rem;
    align-items: center;
  }

  .text-div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 2rem;
  }
`;

export const MobileCardWrapper = styled.div`
  position: relative;
  width: 100%;
  margin-top: 3rem;
  padding-bottom: 2rem;
  min-height: 400px;

  @media (max-width: 400px) {
    min-height: 350px;
  }

  .innerimg {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
  }
`;

export const ImgWrapper = styled.div`
  img {
    width: 100%;
  }

  @media (max-width: 767px) {
    margin-top: 1.5rem;
  }
`;
